import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Client Locations'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Client Locations',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/client-locations',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
